import type { ResponseType } from "@cttq/cttq-request";
import { BaseRequestInstance, AccountRequestInstance } from "./index";
import type { FileDto } from "./interface/public";

export interface Options {
    label: string;
    value: string;
    [property: string]: any;
}

/**
 * CompanyDeptRspDto
 */
export interface CompanyDeptRspDto {
    /**
     * 公司编码
     */
    companyCode?: null | string;
    /**
     * 公司名称
     */
    companyName?: null | string;
    /**
     * 部门编号
     */
    deptCode?: null | string;
    /**
     * 部门名称
     */
    deptName?: null | string;
    [property: string]: any;
}

// 登录用户信息
export const getCurrentUserCompanyDept = () => {
	return BaseRequestInstance.post<ResponseType<CompanyDeptRspDto>>({
		url: "/thirdParty/getCurrentUserCompanyDept"
	});
};

/**
 * CategoryNodeRspDto
 */
export interface CategoryNodeRspDto {
    /**
     * 基类id
     */
    baseCategoryId?: null | string;
    /**
     * 节点列表
     */
    children?: CategoryNodeRspDto[] | null;
    /**
     * 分类编码
     */
    code?: null | string;
    /**
     * 是否有效
     */
    disabled?: boolean | null;
    /**
     * 分类id
     */
    id?: null | string;
    /**
     * 分类名称
     */
    name?: null | string;
    /**
     * 父级id
     */
    pId?: null | string;
    [property: string]: any;
}
/**
 * 品类
 */
export const getCategoryList = (data: any) => {
	return BaseRequestInstance.post<ResponseType<CategoryNodeRspDto[]>>({
		url: "/thirdParty/getCategoryTree",
		data
	});
};

/**
 * FileTempAccessTokenRspDto
 */
export interface FileTempAccessTokenRspDto {
    /**
     * 访问凭证
     */
    accessToken?: null | string;
    /**
     * 存储空间名称
     */
    bucketName?: null | string;
    /**
     * 回调对象
     */
    callback?: Callback;
    /**
     * 临时访问凭证
     */
    credentials?: Credentials;
    /**
     * 文件夹目录
     */
    dir?: null | string;
    /**
     * 地域节点
     */
    endpoint?: null | string;
    /**
     * 地域ID
     */
    regionId?: null | string;
    [property: string]: any;
}

/**
 * 回调对象
 *
 * Callback
 */
export interface Callback {
    /**
     * 回调参数
     */
    callbackBody?: null | string;
    /**
     * 回调参数类型
     */
    callbackBodyType?: null | string;
    /**
     * 回调接口URL
     */
    callbackUrl?: null | string;
    [property: string]: any;
}

/**
 * 临时访问凭证
 *
 * Credentials
 */
export interface Credentials {
    /**
     * 临时访问密钥ID
     */
    accessKeyId?: null | string;
    /**
     * 临时访问密钥
     */
    accessKeySecret?: null | string;
    /**
     * Token到期失效时间（UTC时间）
     */
    expiration?: null | string;
    /**
     * 安全令牌
     */
    securityToken?: null | string;
    [property: string]: any;
}

// 文件上传
export function getTempAccessToken() {
	return BaseRequestInstance.post<ResponseType<FileTempAccessTokenRspDto>>({
		url: "/common/file/getTempAccessToken"
	});
}

/**
 * 法人主体公共类
 *
 * LegalDto
 */
export interface LegalDto {
    /**
     * 法人主体编码
     */
    legalCode: null | string;
    /**
     * 法人主体名称
     */
    legalName: null | string;
    [property: string]: any;
}

// 查询法人主体字典 /thirdParty/getCurrentUserLegalList
export function getAllLegalList() {
	return BaseRequestInstance.post<ResponseType<LegalDto[]>>({
		url: "/thirdParty/getAllLegalList"
	});
}

/**
 * 角色
 *
 * RoleDto
 */
export interface RoleDto {
    /**
     * 角色编码
     */
    roleCode: null | string;
    /**
     * 角色名称
     */
    roleName: null | string;
    [property: string]: any;
}
// 获取角色信息
export function getTspAllRoleList() {
	return BaseRequestInstance.post<ResponseType<RoleDto[]>>({
		url: "/thirdParty/getTspAllRoleList"
	});
}

export interface ProcessRequest {
    /**
     * 申请单编码
     */
    applyCode: string;
    [property: string]: any;
}
/**
 * ProcessNodeRspDto
 */
export interface ProcessNodeRspDto {
    /**
     * 节点标题
     */
    nodeTitle?: null | string;
    /**
     * 操作备注
     */
    operateRemark?: null | string;
    /**
     * 操作时间
     */
    operateTime?: null | string;
    /**
     * 操作类型
     */
    operateType?: number;
    /**
     * 操作类型描述
     */
    operateTypeDesc?: null | string;
    /**
     * 操作人工号
     */
    operatorCode?: null | string;
    /**
     * 申请人所属部门编码
     */
    operatorDeptCode?: null | string;
    /**
     * 申请人所属部门名称
     */
    operatorDeptName?: null | string;
    /**
     * 操作人名称
     */
    operatorName?: null | string;
    [property: string]: any;
}

// 查询审批流程节点
export function getProcessNodeList(params: ProcessRequest) {
	return BaseRequestInstance.get<ResponseType<ProcessNodeRspDto[]>>({
		url: "/apply/common/getProcessNodeList",
		params
	});
}

/**
 * AreaNodeRspDto
 */
export interface AreaNodeRspDto {
    /**
     * 行政区划编码
     */
    areaCode?: null | string;
    /**
     * 等级
     */
    areaLevel?: null | string;
    /**
     * 行政区划名称
     */
    areaName?: null | string;
    /**
     * 节点列表
     */
    list?: AreaNodeRspDto[] | null;
    /**
     * 父级编码
     */
    parentCode?: null | string;
    [property: string]: any;
}

// 获取行政区划信息 /thirdParty/getAreaTree
export function getAreaTree() {
	return BaseRequestInstance.post<ResponseType<AreaNodeRspDto[]>>({
		url: "/thirdParty/getAreaTree"
	});
}

export interface FileRequest {
    /**
     * 文件id
     */
    fileId: string;
    [property: string]: any;
}
// 根据文件id获取文件信息
export function getFileById(params: FileRequest) {
	return BaseRequestInstance.get<ResponseType<FileDto>>({
		url: "/common/file/getFileById",
		params
	});
}
interface UserActionParams {
    account: string | null;
    code: string | null;
  }
// 获取页面权限
export function getUserAction({ account, code }: UserActionParams) {
	return AccountRequestInstance.get<ResponseType>({
		url: `/external-common/users/${account}/apps/SMS/action?resourceCode=${code}`
	});
}
